<template>
  <div
    class="items-center justify-between gap-2 rounded-b-lg bg-white px-3 py-2 text-xs leading-tight text-slate-600/80 sm:flex dark:bg-slate-700 dark:text-slate-400/80"
  >
    <slot></slot>
  </div>
</template>
